import {fetchWikidataEntityDetails, searchWikidataEntities as searchWikidataEntitiesViaSparql} from './wikidataSparql';

const entityDetailsCache = new Map();

/**
 * Shared Wikidata entity search used by the editor and whiteboard flows.
 * Search is backed by the Wikidata SPARQL endpoint's mwapi integration so results
 * can later be enriched via the same endpoint.
 *
 * @param {string} query
 * @returns {Promise<Array>}
 */
export async function searchWikidataEntities(query) {
    try {
        return await searchWikidataEntitiesViaSparql(query, 10);
    } catch (error) {
        console.error('Error searching Wikidata entities:', error);
        return [];
    }
}

/**
 * Shared Wikidata entity detail fetch with a tiny in-memory cache.
 *
 * @param {string} id
 * @returns {Promise<Object|null>}
 */
export async function fetchWikidataEntity(id) {
    if (!id) return null;

    if (!entityDetailsCache.has(id)) {
        entityDetailsCache.set(
            id,
            fetchWikidataEntityDetails(id).catch((error) => {
                entityDetailsCache.delete(id);
                throw error;
            }),
        );
    }

    try {
        return await entityDetailsCache.get(id);
    } catch (error) {
        console.error('Error fetching Wikidata entity:', error);
        return null;
    }
}

